import '@swc/helpers';
import 'react';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';

const useBloomreachPageName = ()=>{
    const page = useBrPageContext();
    return page === null || page === void 0 ? void 0 : page.getComponent().getName();
};

export { useBloomreachPageName };
//# sourceMappingURL=use-bloomreach-page-name.js.map
